module.exports = __webpack_public_path__ + "img/ursa_minor.a655e3f3.png";